import { Routes } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { CallbackComponent } from './pages/callback/callback.component';
import { LogoutComponent } from './pages/logout/logout.component';

export const authRoutes: Routes = [
  {
    path: 'auth',
    children: [
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full',
      },
      {
        path: 'login',
        component: LoginComponent,
      },
      {
        path: 'callback',
        component: CallbackComponent,
      },
      {
        path: 'logout',
        component: LogoutComponent,
      },
      {
        path: 'redirect',
        redirectTo: '/dashboard',
        pathMatch: 'full',
      },
    ],
  },
];
